/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  app.ImagePopupView = app.View.extend({
    tagName: 'div',
    className: 'b-popup image-popup',
    
    events: {
      'click .product-preview_close': 'closePopup',
    },
    
    run: function (options) {
      this.imageUrl = options.imageUrl;
      this.alt = options.alt;
      this.zoom = options.zoom;
      this.overlay = $('.overlay-blue');
      this.offset = options.offset;
      this.parent = options.parent;
      this.listenTo(this.parent, 'mouseout', this.closePopup);
      this.render();
      this.listenTo(app.overlayView, 'overlayClose', this.closePopup);
    },
    
    setPosition: function () {
      var top = $(window).scrollTop() + $(window).outerHeight() / 6,
        left = $(window).outerWidth() / 6,
        paddingRight = '50px';
      
      if (this.zoom) {
        top = this.offset.top;
        left = this.offset.left;
        paddingRight = '5px';
      }
      
      this.$el.css({
        'top': top,
        'left': left,
        'max-width': '70%',
        'padding-right': paddingRight,
        'text-align': 'center'
      });
      this.$el.find('img').addClass('image-popup-img');
    },
    
    closePopup: function () {
      this.overlay.toggleClass('not_display');
      this.remove();
    },
    
    render: function () {
      var content = '<img src="' + this.imageUrl + '" alt="' + this.alt + '">';
      if (!this.zoom) {
        content += '<div class="product-preview_close"></div>';
      }
      
      this.$el.append(content);
      this.overlay.toggleClass('not_display');
      this.$el.appendTo('body');
      
      this.setPosition();
    }
  });
})(jQuery);

}.call(window));